/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planner_Failed_SetupInputs */

const en_planner_failed_setup = /** @type {(inputs: Planner_Failed_SetupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI isn’t set up yet (Settings → AI).`)
};

const de_planner_failed_setup = /** @type {(inputs: Planner_Failed_SetupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die KI ist noch nicht eingerichtet (Einstellungen → KI).`)
};

/**
* | output |
* | --- |
* | "AI isn’t set up yet (Settings → AI)." |
*
* @param {Planner_Failed_SetupInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const planner_failed_setup = /** @type {((inputs?: Planner_Failed_SetupInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planner_Failed_SetupInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_planner_failed_setup(inputs)
	return en_planner_failed_setup(inputs)
});